import { Box, Container, Typography, IconButton, Link, Grid, Divider, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Link as RouterLink } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        py: 4,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.background.paper,
        borderTop: `2px solid ${alpha(theme.palette.primary.main, 0.40)}`,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              BrainLoop
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              Helping students achieve better learning outcomes with AI-enhanced study tools.
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={4} sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                component={RouterLink}
                to="/faq"
                color="text.secondary"
                sx={{ textDecoration: 'none' }}
              >
                FAQ
              </Link>
              <Link
                component={RouterLink}
                to="/dashboard"
                color="text.secondary"
                sx={{ textDecoration: 'none' }}
              >
                Dashboard
              </Link>
              <Link
                component={RouterLink}
                to="/notes"
                color="text.secondary"
                sx={{ textDecoration: 'none' }}
              >
                Notes
              </Link>
            </Box>
          </Grid>

          {/* Legal */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" color="text.primary" gutterBottom>
              Legal
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                component={RouterLink}
                to="/terms"
                color="text.secondary"
                sx={{ textDecoration: 'none' }}
              >
                Terms of Service
              </Link>
              <Link
                component={RouterLink}
                to="/privacy"
                color="text.secondary"
                sx={{ textDecoration: 'none' }}
              >
                Privacy Policy
              </Link>
              <Link
                component={RouterLink}
                to="/privacy#cookies"
                color="text.secondary"
                sx={{ textDecoration: 'none' }}
              >
                Cookie Policy
              </Link>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3, borderColor: alpha(theme.palette.primary.main, 0.30) }} />

        {/* Bottom Section */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {currentYear} BrainLoop. All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <IconButton
              component={Link}
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              component={Link}
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              component={Link}
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <InstagramIcon />
            </IconButton>
            <IconButton
              component={Link}
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedInIcon />
            </IconButton>
          </Box>
        </Box>
      </Container>
    </Box>
  );
} 